'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dVar$002dSignal from "./com.raquo.airstream.state.-Var-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_state_SourceVar(initial) {
  this.F7 = null;
  this.yS = null;
  this.yQ = null;
  this.yP = null;
  this.yR = null;
  this.F7 = (void 0);
  $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__$init$__V(this);
  this.yQ = initial;
  this.yP = new $j_com$002eraquo$002eairstream$002estate$002e$002dVar$002dSignal.$c_Lcom_raquo_airstream_state_VarSignal(this.yQ, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this))));
  this.yR = this.yP;
}
export { $c_Lcom_raquo_airstream_state_SourceVar as $c_Lcom_raquo_airstream_state_SourceVar };
$p = $c_Lcom_raquo_airstream_state_SourceVar.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_SourceVar;
/** @constructor */
function $h_Lcom_raquo_airstream_state_SourceVar() {
}
export { $h_Lcom_raquo_airstream_state_SourceVar as $h_Lcom_raquo_airstream_state_SourceVar };
$h_Lcom_raquo_airstream_state_SourceVar.prototype = $p;
$p.dP = (function() {
  return this.F7;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.uI = (function() {
  return this.yS;
});
$p.Bg = (function(x$0) {
  this.yS = x$0;
});
$p.lh = (function() {
  return this.yS;
});
$p.rl = (function(value, transaction) {
  this.yQ = value;
  $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this.yP, value, transaction);
});
$p.a4 = (function() {
  return this.yR;
});
$p.dS = (function() {
  return this.yR;
});
var $d_Lcom_raquo_airstream_state_SourceVar = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_state_SourceVar, "com.raquo.airstream.state.SourceVar", ({
  hk: 1,
  a1: 1,
  au: 1,
  aP: 1,
  M: 1,
  c4: 1
}));
export { $d_Lcom_raquo_airstream_state_SourceVar as $d_Lcom_raquo_airstream_state_SourceVar };
